<template>
  <div class="produceInformationHeat table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      生產資訊
    </li>
    <b-table
      :items="produceInformationHeatItem"
      :fields="produceInformationHeatFields"
      class="text-center produceInformationHeat-table-detail"
    >
      <template #head(item_title)="">
        <div class="produceInformationHeat-table-line">
          <span class="produceInformationHeat-table-item">項目</span>
          <span class="produceInformationHeat-table-status">狀態</span>
        </div>
      </template>
      <template #cell(work_dispatch_weight)="data">
        {{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}
      </template>
      <template #cell(work_total_weight)="data">
        {{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}
      </template>
      <template #cell(work_in_weight)="data">
        {{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "produceInformationHeat",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      produceInformationHeatFields:
        "produceInformationHeat/get_produceInformationHeatFields",
      produceInformationHeatItem:
        "produceInformationHeat/get_produceInformationHeatItem"
    })
  }
};
</script>

<style lang="scss">
.produceInformationHeat-table-line {
  border-top: 2.8rem #cccccc solid; /*上邊框寬度等於表格第一行行高*/
  width: 0px; /*讓容器寬度為0*/
  height: 0px; /*讓容器高度為0*/
  border-left: 5rem #bdbdbd solid; /*左邊框寬度等於表格第一行第一格寬度*/
  position: relative; /*讓裡面的兩個子容器絕對定位*/
  color: #000000;
}
.produceInformationHeat-table-item {
  font-style: normal;
  display: block;
  position: absolute;
  top: -43px;
  left: -40px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}
.produceInformationHeat-table-status {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  left: -85px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}

.produceInformationHeat-table-detail thead th {
  border-top: 1px solid;
}
.produceInformationHeat-table-detail th,
.produceInformationHeat-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.produceInformationHeat-table-detail th:first-child,
.produceInformationHeat-table-detail td:first-child {
  border-left: 1px solid;
}
.produceInformationHeat-table-detail {
  margin-bottom: 0px;
}
.produceInformationHeat-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.produceInformationHeat-table-detail thead tr:last-child th:nth-child(1) {
  width: 5rem;
  min-width: 5rem;
}
.produceInformationHeat-table-detail thead tr:last-child th:nth-child(2) {
  min-width: 8rem;
}
.produceInformationHeat-table-detail thead tr:last-child th:nth-child(3) {
  min-width: 10rem;
}
.produceInformationHeat-table-detail thead tr:last-child th:nth-child(4) {
  min-width: 10rem;
}
.produceInformationHeat-table-detail thead tr:last-child th:nth-child(5) {
  width: 27rem;
  min-width: 23rem;
}
.produceInformationHeat-table-detail thead tr:last-child th:nth-child(6) {
  width: 27rem;
  min-width: 23rem;
}
.produceInformationHeat-table-detail tr td {
  background-color: #ffffff;
}
.produceInformationHeat-table-detail tr td:nth-child(1) {
  background-color: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/produceInformationHeat.vue